import Api from './api';

export const fetchSectionPath = (cspace, sectionId) => {
  return Api.get(`/cm/public/${cspace}/sections/${sectionId}/path`);
};

export const fetchSectionArticles = (cspace, sectionId, extraParams = {}) => {
  return Api.get(
    `/cm/public/${cspace}/sections/${sectionId}/articles`,
    extraParams,
  );
};

export const fetchSections = (cspace, sectionId) => {
  return Api.get(`/cm/public/${cspace}/sections/${sectionId}/sections`);
};

export const fetchArticles = (cspace, extraParams = {}) => {
  return Api.get(`/cm/public/${cspace}/articles`, extraParams);
};

export const fetchArticleRelated = (cspace, articleId, limit = 10) => {
  return Api.get(
    `/cm/public/${cspace}/articles/${articleId}/related?limit=${limit}`,
  );
};

export const saveArticleStats = (cspace, articleId) => {
  return Api.post(`/cm/public/${cspace}/articles/${articleId}/stats`);
};



// WEBPACK FOOTER //
// ./src/ui/src/csm.service.js